<template>
  <div class="accredit-dialog">
    <el-dialog title="学生授权给指定导师" :visible.sync="accreditDialogShow" width="750px" :before-close="dialogClose"
      @open="dialogOpen">
      <el-table ref="multipleTable" :data="specialTutorList" tooltip-effect="dark" max-height="400px"
        style="width: 95%; margin: 0 auto;">
        <el-table-column prop="teacherName" label="教师姓名">
        </el-table-column>
        <el-table-column prop="teacherNumber" label="教师工号">
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <div class="handle-container">
              <el-button type="success" size="small" @click="accredit(scope.row)">授权
              </el-button>
              <el-button type="info" size="small" @click="cancelAccredit(scope.row)">撤销
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="btn-list">
        <el-button type="primary" @click="submit">确认</el-button>
      </div> -->
      <div class="pagination-catainer">
        <pagination :total="parseInt(specialTutorTotal)" :pageSize="parseInt(pageInfo.pageSize)"
          @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'accreditDialogShow',
    'accreditStudentsData',
    'specialTutorList',
    'specialTutorTotal',
    'pageInfo'
  ],
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
      }, {
        date: '2016-05-04',
      }, {
        date: '2016-05-01',
      }, {
        date: '2016-05-03',
      }],
    };
  },
  methods: {
    // 授权
    accredit(row) {
      let data = {
        "studentId": this.accreditStudentsData.id,
        "mentorId": row.teacherId
      };
      this.put(this.$url.studentDelegationTutor, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      })
    },
    // 撤销授权
    cancelAccredit(row) {
      let data = {
        "studentId": this.accreditStudentsData.id,
        "mentorId": row.teacherId
      };
      this.put(this.$url.studentDelegationRevocationTutor, data).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      })
    },
    // 开启弹窗
    dialogOpen() {
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:accreditDialogShow", false);
      this.$emit("refreshPageData");
    },
    currentPageNumChange(pageNum) {
      this.$emit("currentPageNumChange", pageNum);
    },
    handleSizeChange(pageSize) {
      this.$emit("handleSizeChange", pageSize);
    },
    submit() {

    }
  },
};
</script>

<style lang="scss" scoped>
@import "./accreditDialog.scss";
</style>